import QuestionListItem from "./Question-List-Item";
import './expert.css';
import {ru} from "../../data/ru";
import {by} from "../../data/by";

const QuestionList = ({items, setQuestion, setIsChecked, isChecked}) => {
    const language = localStorage.getItem('lang') === 'ru' ? ru.RoleIdSix : by.RoleIdSix;
    let elements = [];
    let length = isChecked ? items.length : Math.min(10, items.length);
    for (let i = 0; i < length; i++) {
        let {idQuestion} = items[i]
        elements.push(
            <div key={idQuestion}>
                <QuestionListItem
                    key={idQuestion}
                    {...items[i]}
                    setQuestion={setQuestion}
                    isChecked={isChecked}
                />
            </div>
        )
    }
    return (
        <div className="expert_questions">
            <div style={{'display': 'flex'}}>
                <p className={`expert_counter ${isChecked === 0 ? 'expert_counter_active' : ''}`}
                   onClick={e => setIsChecked(0)}>{language.underReview}{isChecked === 0 && <>: {items.length}</>}</p>
                <p className={`expert_counter ${isChecked === 1 ? 'expert_counter_active' : ''}`}
                   onClick={e => setIsChecked(1)}>{language.verified}{isChecked === 1 && <>: {items.length}</>}</p>
            </div>
            {elements}
        </div>
    )
}

export default QuestionList;
